import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { T } from "./translations";
import { safeGet } from "@/lib/api";
import { applyOverrides, dbLocale } from "@/lib/siteTexts";

const I18nCtx = createContext(null);

const HTML_LANG = { it: "it", en: "en", es: "es", pt: "pt-BR" };

const detect = () => {
  const saved = localStorage.getItem("ananawi_lang");
  if (saved && T[saved]) return saved;
  const nav = (navigator.language || "it").slice(0, 2).toLowerCase();
  return T[nav] ? nav : "it";
};

export const I18nProvider = ({ children, initialLang }) => {
  const [lang, setLang] = useState(() => (initialLang && T[initialLang] ? initialLang : detect()));
  const [overrides, setOverrides] = useState(null);
  const reloadTexts = useCallback(async () => {
    const data = await safeGet("/texts", null);
    setOverrides(data && typeof data === "object" ? data : null);
  }, []);
  useEffect(() => {
    reloadTexts();
  }, [reloadTexts]);
  useEffect(() => {
    localStorage.setItem("ananawi_lang", lang);
    // Separate URLs per language now exist, so the document language reflects
    // the active language: it / en / es / pt-BR.
    document.documentElement.lang = HTML_LANG[lang] || "it";
  }, [lang]);
  const value = useMemo(
    () => ({ lang, setLang, t: applyOverrides(T[lang], overrides?.[dbLocale(lang)]), overrides, reloadTexts }),
    [lang, overrides, reloadTexts]
  );
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);
